// /sync?code=XXXX-XXXX: where the bot's "Open Chefi to finish" button lands. The same page works when the
// address is copied into any browser: it only holds a code to type or confirm, and the code is single-use.
import React from 'react';
import { useRoute, type RouteProp } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { Screen, Title } from '../components/ui';
import SyncBox from '../components/SyncBox';
import { type AllParams } from '../navigation';

export default function SyncScreen() {
  const { t } = useTranslation();
  const code = useRoute<RouteProp<AllParams, 'Sync'>>().params?.code ?? '';
  return (
    <Screen>
      <Title>{t('sync.title')}</Title>
      <SyncBox initialCode={code} />
    </Screen>
  );
}
